import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";


const LOCAL_STORAGE_KEY = "headerSettings";

const defaultValues = {
    name: "",
    tele: "",
    email: "",
    web: "",
    address: "",
    logoUrl: "",
    serialNumber: "",
};

export default function HeaderSettingsPopup({ open, onClose }) {
    const { t } = useTranslation();
    const [values, setValues] = useState(defaultValues);

     const [serialNumber, setSerialNumber] = useState('');
   

    useEffect(() => {
        const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
        const now = new Date();
        const yy = String(now.getFullYear()).slice(-2);
        const MM = String(now.getMonth() + 1).padStart(2, '0');
        const dd = String(now.getDate()).padStart(2, '0');
        const hh = String(now.getHours()).padStart(2, '0');
        const m = String(now.getMinutes()).padStart(2, '0');
        const result = yy + MM + dd + hh + m;
        setSerialNumber(result);
        if (stored) {
            setValues({ ...JSON.parse(stored) , serialNumber: result });
        }
    }, [open]);

    

    const handleChange = (e) => {
        setValues({ ...values, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(values));
        if (onClose) onClose();
    };

    const handleClose = () => {
        if (onClose) onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{t("HeaderSettingsTitle")}</DialogTitle>
            <DialogContent>
                <TextField
                    margin="dense"
                    label={t("Name")}
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    margin="dense"
                    label={t("Telephone")}
                    name="tele"
                    value={values.tele}
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    margin="dense"
                    label={t("Email")}
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    margin="dense"
                    label={t("Website")}
                    name="web"
                    value={values.web}
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    margin="dense"
                    label={t("Address")}
                    name="address"
                    value={values.address}
                    onChange={handleChange}
                    fullWidth
                />
                {/* <TextField
                    margin="dense"
                    label="Logo URL"
                    name="logoUrl"
                    value={values.logoUrl}
                    onChange={handleChange}
                    fullWidth
                /> */}
                <TextField
                    margin="dense"
                    label={t("FileNo")}
                    name="serialNumber"
                    value={values.serialNumber}
                    onChange={handleChange}
                    fullWidth
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="info">{t("HC.CANCEL")}</Button>
                <Button onClick={handleSave} variant="text" >
                    {t("Save")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

HeaderSettingsPopup.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};
